import {
  ConeGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Compact Annie mesh — red dress + teddy cue (keeps meshFactory closed). */
export function createAnnieMesh(team = 'blue') {
  const group = new Group();
  const dress = team === 'blue' ? 0xb91c1c : 0x7f1d1d;
  const dressMat = new MeshStandardMaterial({ color: dress, roughness: 0.55 });
  const skinMat = new MeshStandardMaterial({ color: 0xffedd5, roughness: 0.7 });
  const bearMat = new MeshStandardMaterial({ color: 0x7c2d12, roughness: 0.8 });

  const body = new Mesh(new ConeGeometry(0.7, 2.2, 10), dressMat);
  body.position.y = 1.3;
  group.add(body);

  const head = new Mesh(new SphereGeometry(0.42, 12, 12), skinMat);
  head.position.y = 2.7;
  group.add(head);

  const bear = new Mesh(new SphereGeometry(0.35, 10, 10), bearMat);
  bear.position.set(0.55, 1.6, 0.35);
  group.add(bear);

  return group;
}
